import Image from "next/image";
import Link from "next/link";
import { useAppContext } from "@/context/Context";
import { ImmigrationGurusSvg } from "@/public/images/Svgs/ImmigirationsSvg";
import guru from "../../../images/guru.jpeg";
import { useState } from "react";
import { useRouter } from "next/router";
import { ASSETS_URL } from "@/Constant";
import find_in_page from "../../../public/images/banner/find_in_page.svg";
/**
 *
 * @param {*} param0
 * @returns
 */

const CourseTabs = ({
  course,
  start,
  end,
  Projects,
  childDataCallable = "Courses",
  nameKey = "name",
}) => {
  const router = useRouter();
  const currentPath = router.pathname;

  const { toggle } = useAppContext();

  const [errorImages, setErrorImages] = useState({});

  const handleError = (index) => {
    setErrorImages((prev) => ({ ...prev, [index]: true }));
  };

  const buttonClass = {
    width: "100%",
    textAlign: "center",
    fontFamily: '"Noto Sans", sans-serif',
    fontWeight: 600,
    fontSize: "16px",
    color: "#000000",
    borderRadius: "56px",
    border: "1px solid #000000",
    padding: "13px 24px",
    cursor: "pointer",
  };

  return (
    <>
      <div
        className={`rbt-course-grid-column ${
          Projects?.[childDataCallable]?.length === 0 && "w-full"
        } ${!toggle ? "active-list-view" : ""}`}
      >
        {Projects?.[childDataCallable]?.length === 0 ? (
          <div
            className="rbt-sidebar-widget-wrapper w-full"
            style={{
              minHeight: "400px",
              display: "flex",
              alignItems: "center",
              marginTop: "3rem",
              width: "100%",
            }}
          >
            {" "}
            <div
              className="flex flex-col items-center justify-center p-8 rounded-lg w-full max-w-md mx-auto my-8"
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div className="flex justify-center items-center mb-4"></div>
              <div
                className="flex gap-2 items-start"
                style={{
                  display: "flex",
                  gap: "8px",
                }}
              >
                <div className="mt-2">
                  <Image
                    src={find_in_page}
                    width={24}
                    height={24}
                    alt="Hero Image"
                  />
                </div>
                <div>
                  <span
                    style={{
                      color: "#4D4D4D",
                      fontWeight: "500",
                      fontSize: "26px",
                    }}
                  >
                    We couldn't find any {childDataCallable}
                  </span>
                  <ul
                    style={{
                      fontWeight: "400",
                      fontSize: "16px",
                      color: "#4D4D4D",
                    }}
                  >
                    <li>Check your filters and search for typos</li>
                    <li>Use more generic search terms</li>
                    <li>Reach out to us at info@immigurus.com for support</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : (
          Projects?.[childDataCallable]?.map((data, index) => (
            <div
              className="course-grid-3"
              key={index}
              style={{
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              <div
                className={`rbt-card variation-01 rbt-hover ${
                  !toggle ? "card-list-2" : ""
                } block`}
                style={{
                  display: "block",
                }}
              >
                <div className="rbt-card-body tig-card-padding-top-none">
                  <h4 className="tig-card-header">
                    <div href={`/course-details/${data?.id}`}>
                      <div
                        className="rbt-card-img"
                        style={{
                          backgroundImage: !errorImages[index]
                            ? `url(${ASSETS_URL}/uploads/Universities/${
                                data?.university?.id ?? data?.id
                              }/logo/${
                                data?.logo?.src ?? data?.university?.logo?.src
                              })`
                            : guru,
                          backgroundSize: "contain",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          height: "60px",
                          width: "60px",
                        }}
                      ></div>
                    </div>
                  </h4>
                  <h3 className="tig-card-subheader">
                    <div href={`/course-details/${data?.id}`}>
                      {data?.[nameKey]}
                    </div>
                  </h3>
                  <hr></hr>
                  <ul
                    className="rbt-sidebar-list-wrapper categories-list-check has-show-more-inner-content list-none"
                    style={{
                      listStyleType: "none",
                      paddingLeft: "0px",
                    }}
                  >
                    <li className="rbt-check-group">
                      <label
                        htmlFor="flex gap-2"
                        className="text-[1rem]"
                        style={{
                          display: "flex",
                          gap: 10,
                          justifyContent: "normal",
                          fontSize: "16px",
                        }}
                      >
                        <span
                          className="flex items-center"
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {ImmigrationGurusSvg?.rankingSvg}
                        </span>{" "}
                        THE World Ranking: {data?.worldRank}
                      </label>
                    </li>

                    <li className="rbt-check-group">
                      <label
                        htmlFor="cat-list-3"
                        className="text-[1rem]"
                        style={{
                          display: "flex",
                          gap: 10,
                          justifyContent: "normal",
                          fontSize: "16px",
                        }}
                      >
                        <span
                          className="flex items-center"
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {ImmigrationGurusSvg.locationSvg}
                        </span>{" "}
                        {data?.country?.name}
                      </label>
                    </li>
                    {data?.nextIntake && (
                      <li className="rbt-check-group">
                        <label
                          htmlFor="cat-list-4"
                          className="text-[1rem]"
                          style={{
                            display: "flex",
                            gap: 10,
                            justifyContent: "normal",
                            fontSize: "16px",
                          }}
                        >
                          <span
                            className="flex items-center"
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {ImmigrationGurusSvg.intakeSvg}
                          </span>{" "}
                          {data?.nextIntake}
                        </label>
                      </li>
                    )}

                    <li className="rbt-check-group">
                      <label
                        htmlFor="cat-list-5"
                        className="text-[1rem]"
                        style={{
                          display: "flex",
                          gap: 10,
                          justifyContent: "normal",
                          fontSize: "16px",
                        }}
                      >
                        <span
                          className="flex items-center"
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {ImmigrationGurusSvg.currencySvg}
                        </span>{" "}
                        {data?.country?.currency}
                        {data?.fees}
                      </label>
                    </li>
                  </ul>
                  <div className="flex d-flex">
                    <Link
                      style={buttonClass}
                      className="mt--10 cursor-pointer hover:bg-blue-500  hovered_bg_colour "
                      href={
                        currentPath === "/study-courses"
                          ? `/study-courses/${data?.id}`
                          : `/universitycollege/${data?.id}`
                      }
                    >
                      View Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default CourseTabs;
